import { useState, useEffect } from "react";
import { Col, Form, Modal, Row, Alert } from "react-bootstrap";
import { AddNewWeldingProcess, UpdateWeldingProcess } from "../../Services/weldingprocess-services";
import SuccessAlertModal from "../Modals/successAlertModal";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import { useNavigate } from "react-router-dom";
import { isAlphanumericWithDotSpaceDashCommaBrackets } from "../../functions/validations";
import { showSuccess, showWarning } from "../utility/ui/notifications/Toaster";
import ButtonModal from "../Modals/buttonModal";
import { SearchSelect } from "../utility/forms/inputs/search-select";
import { normalstyle } from "../../functions/welding-functions";
import PropTypes from 'prop-types';
import { Process_Cat } from "../../Components/utility/common/TransactionComponents/TransactionEntity"

const AddEditWeldingProcessMaster = (props) => {
  AddEditWeldingProcessMaster.propTypes = {
    allRecs: PropTypes.array,
    rowdata: PropTypes.object,
    action: PropTypes.string,
    onHide: PropTypes.func,
    setReload: PropTypes.func,
    reload: PropTypes.bool
  };
  if (props.rowdata.wld_status === "Active") {
    props.rowdata.wld_status = true;
  } else if (props.rowdata.wld_status === "Inactive") {
    props.rowdata.wld_status = false;
  }

  let action = props.action;
  let formName = "WeldingProcess";

  const [showSuccessModel, setShowSuccessModel] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showConfirmModel, setshowConfirmModel] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [toggleClass, setToggleClass] = useState(
    (action === "Edit" ? props.rowdata.wld_status : true) ? "activeToggleLabel" : "inactiveToggleLabel"
  );
  const history = useNavigate();
  let username = sessionStorage.getItem("UserName");


  const [WeldingProcessObj, setWeldingProcessObj] = useState(
    action === "Edit"
      ? props.rowdata
      : {
        wld_status: true,
        wld_code: "",
        wld_p_category: "",
        wld_description: "",
        SK: "",
        PK: "WeldingProcess",
        wld_createdby: "",
        wld_createdon: "",
        wld_updatedby: "",
        wld_updatedon: "",
      }
  );
  const [error, setError] = useState({
    SK: {},
    PK: {},
    wld_status: {},
    wld_code: {},
    wld_p_category: {},
    wld_description: {},
    wld_createdby: {},
    wld_createdon: {},
    wld_updatedby: {},
    wld_updatedon: {},
  });
  const modalOnClick = () => {
    history.push({
      pathname: "/",
      data: "setWeldingProcess",
    });
  };

  const handleCloseSuccess = () => {
    setShowSuccessModel(false);
    props.onHide();
    props.setReload(!props.reload);
  };
  const handleCloseConf = () => {
    setshowConfirmModel(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setWeldingProcessObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((prevState) => ({
      ...prevState,
    }));
  };

  const handleSwitchChange = (e) => {
    if (e.target.checked) {
      setToggleClass("activeToggleLabel")
    } else {
      setToggleClass("inactiveToggleLabel")
    }

    setWeldingProcessObj((prevState) => ({
      ...prevState,
      wld_status: e.target.checked,
    }));
  };

  const resetForm = () => {
    if (action === "Add") {
      setWeldingProcessObj((prevState) => ({
        ...prevState,
        wld_status: true,
        wld_code: "",
        wld_p_category: "",
        wld_description: "",
        SK: "",
        wld_createdby: "",
        wld_createdon: "",
      }));
      setToggleClass("activeToggleLabel");
    } else if (action === "Edit") {
      setWeldingProcessObj((prevState) => ({
        ...prevState,
        PK: props.rowdata.PK,
        SK: props.rowdata.SK,
        wld_status: props.rowdata.wld_status,
        wld_code: props.rowdata.wld_code,
        wld_p_category: props.rowdata.wld_p_category,
        wld_description: props.rowdata.wld_description,
        wld_createdby: props.rowdata.wld_createdby,
        wld_createdon: props.rowdata.wld_createdon,
      }));
      setToggleClass(props.rowdata.wld_status ? "activeToggleLabel" : "inactiveToggleLabel");
    }
    setError((prevState) => ({
      ...prevState,
      wld_code: {},
      wld_p_category: {},
      wld_description: {},
      SK: {},
    }));
  };

  const validateWeldingProcess = (action) => {
    let result = false;

    if (WeldingProcessObj.wld_code.trim() === "") {
      WeldingProcessObj.wld_code = "";
      error.wld_code = {
        status: true,
        message: "Welding Process Number is required",
      };
    } else {
      error.wld_code = {
        status: false,
        message: "",
      };
    }
    if (WeldingProcessObj.wld_p_category.trim() === "") {
      WeldingProcessObj.wld_p_category = "";
      error.wld_p_category = {
        status: true,
        message: "Process Category is required.",
      };
    } else {
      error.wld_p_category = {
        status: false,
        message: "",
      };
    }
    if (WeldingProcessObj.wld_description.trim() === "") {
      WeldingProcessObj.wld_description = "";
      error.wld_description = {
        status: true,
        message: "Process Description is required.",
      };
    } else {
      error.wld_description = {
        status: false,
        message: "",
      };
    }
    if (WeldingProcessObj.wld_status === "") {
      error.wld_status = {
        status: true,
        message: "Status is required.",
      };
    }

    if (action === "Add") {
      result = props.allRecs?.find(
        (item) =>
          item.PK.toLowerCase() === WeldingProcessObj.PK.toLowerCase() &&
          item.SK.toLowerCase() === WeldingProcessObj.wld_code.toLowerCase()
      );
    }

    if (result) {
      setAlertMessage("Process  Combination Already Exists!");
    }

    setError((prevState) => ({
      ...prevState,
      ...error,
    }));

    return (
      error.SK.status ||
      error.wld_code.status ||
      error.wld_p_category.status ||
      error.wld_description.status ||
      result
    );
  };

  const handleAdd = (e) => {
    let result;
    if (WeldingProcessObj.wld_status === true) {
      WeldingProcessObj.wld_status = "Active";
    } else {
      WeldingProcessObj.wld_status = "Inactive";
    }
    if (action === "Add") {
      WeldingProcessObj.SK = WeldingProcessObj.wld_code;
      WeldingProcessObj.wld_createdby = username;

      result = AddNewWeldingProcess(WeldingProcessObj);
    } else {
      WeldingProcessObj.wld_updatedby = WeldingProcessObj.wld_createdby;

      result = UpdateWeldingProcess(WeldingProcessObj);
    }
    result
      .then((resp) => {
        if (action === "Edit") {
          showSuccess(`Selected Welding Process has been Updated successfully`);
        }
        if (resp.message === "Duplicate") {
          showWarning(resp.message);
        } else if (action === "Add") {
          showSuccess(`Selected Welding Process has been Added successfully`);
        }
        props.setReload(!props.reload);
        setShowForm(false);
        props.onHide();
      })
      .catch((error) => {
        showWarning(`User Add/Update Failed:`);
        props.setReload(!props.reload);
        setShowForm(false);
        props.onHide();
      })
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateWeldingProcess(action)) {
      setshowConfirmModel(true);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlertMessage("");
    }, 10000);
    return () => clearTimeout(timer);
  }, [alertMessage]);

  return (
    <>
      <SuccessAlertModal
        clickFunction={modalOnClick}
        msg={`Great! You've ${action}ed Welding Process successfully.`}
        show={showSuccessModel}
        handleClose={handleCloseSuccess}
      />
      <ConfirmAlertModal
        action={action}
        handleYes={handleAdd}
        formName={formName}
        show={showConfirmModel}
        handleClose={handleCloseConf}
      />
      <Modal
        {...props}
        size="lg"
        centered
        className={
          showForm || showSuccessModel || showConfirmModel
            ? "opacity-0 userMasterModal"
            : "opacity-100 userMasterModal"
        }
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{action} Welding Process </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit} autoComplete="off">
          <Modal.Body>
            <div className="px-2">
              <Row className="gx-3">
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        type="text"
                        id="wld_code"
                        name="wld_code"
                        placeholder=" "
                        disabled={action === "Edit" ? true : false}
                        maxLength="50"
                        className={
                          error.wld_code.status
                            ? " g-input placeHolderInput inputText text-field-with-error allow"
                            : "g-input placeHolderInput inputText allow"
                        }
                        value={WeldingProcessObj.wld_code}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error =
                            isAlphanumericWithDotSpaceDashCommaBrackets(
                              e.target.value
                            );
                          setError((prevState) => ({
                            ...prevState,
                            wld_code: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_code">
                        Process {" "}
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                  </Form.Group>
                  {error.wld_code.status && (
                    <Form.Text className="text-danger">
                      <span style={{ position: "relative", bottom: "42px" }}>
                        {error.wld_code.message}
                      </span>{" "}
                    </Form.Text>
                  )}
                </Col>
                <Col md={4}>
                  <Form.Group className="ListW-input-select">
                    <div className="search-select">
                      <SearchSelect
                        id="wld_p_category"
                        name="wld_p_category"
                        className={""}
                        stylegreen={normalstyle}
                        data={Process_Cat}
                        valueField={"value"}
                        value={WeldingProcessObj?.wld_p_category}
                        labelField={"name"}
                        placeholder=""
                        onChange={(ProjectList) => {
                          setWeldingProcessObj((prev) => ({
                            ...prev,
                            wld_p_category: ProjectList.value,
                          }));
                        }}
                      ></SearchSelect>
                    </div>
                    <Form.Label> Process Category</Form.Label>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_description"
                        name="wld_description"
                        type="text"
                        maxLength="50"
                        className={`asterisk ${error.wld_description.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={WeldingProcessObj.wld_description}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error =
                            isAlphanumericWithDotSpaceDashCommaBrackets(
                              e.target.value
                            );
                          setError((prevState) => ({
                            ...prevState,
                            wld_description: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_description">
                        Process Description
                      </Form.Label>
                    </div>
                  </Form.Group>
                  {error.wld_description.status && (
                    <Form.Text className="text-danger">
                      <span style={{ position: "relative", bottom: "10px" }}>
                        {error.wld_description.message}
                      </span>{" "}
                    </Form.Text>
                  )}
                </Col>
                <Col lg={4} md={12}>
                  <Form.Group className="form-switch-input mt-1">
                    <Form.Label className="fieldLabel mb-0">Status</Form.Label>
                    <Form.Switch
                      className={"semiBoldToggleButton " + toggleClass}
                      name="wld_status"
                      checked={WeldingProcessObj.wld_status}
                      onChange={handleSwitchChange}
                    />
                    <span className={"fieldLabel " + toggleClass}>
                      {WeldingProcessObj.wld_status ? "Active" : "Inactive"}
                    </span>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            {alertMessage && (
              <Alert className="alertBox" variant="warning">
                {alertMessage}
              </Alert>
            )}
          </Modal.Body>
          <Row>
            <ButtonModal action={action} resetForm={resetForm}></ButtonModal>
          </Row>
          <Row>
            <br></br>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddEditWeldingProcessMaster;